import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type MonthPickerProps = {
  valueKey: string,
  setDate: (key: string, date: Date) => void
}

export const MonthPicker = ({valueKey, setDate}: MonthPickerProps) => {
  const [currentDate, setCurrentDate] = useState<Date | null>(null);

  return (
    <div>
      <DatePicker
        selected={currentDate}
        onChange={(newDate) => { setDate(valueKey, newDate); setCurrentDate(newDate); }}
        dateFormat="yyyy-MM"
        showMonthYearPicker
      />
    </div>
  );
};
